import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type PermanentStore = {
  shouldShowAutoFeedbackModal: boolean
  autoFeedbackModalTimerStart: Date | null

  setShouldShowAutoFeedbackModal: (show: boolean) => void
  setAutoFeedbackModalTimerStart: (date: Date | null) => void
}

export const usePermanentStore = create<PermanentStore>()(
  persist(
    (set, get) => ({
      shouldShowAutoFeedbackModal: false,
      setShouldShowAutoFeedbackModal: (show: boolean) => set({ shouldShowAutoFeedbackModal: show }),

      autoFeedbackModalTimerStart: null,
      setAutoFeedbackModalTimerStart: (date: Date | null) => {
        if (get().shouldShowAutoFeedbackModal === true) {
          set({ autoFeedbackModalTimerStart: date })
        }
      },
    }),
    {
      name: 'cobrief-permanent-store',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)